export default "__VITE_ASSET__ycGgZbad__"